import { render, staticRenderFns } from "./StoreyAdd.vue?vue&type=template&id=6dfd654b&scoped=true"
import script from "./StoreyAdd.vue?vue&type=script&lang=js"
export * from "./StoreyAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfd654b",
  null
  
)

export default component.exports